// V2 "New Season" API client: farming unit -> field (field_group) -> block -> season.
//
// Platform-agnostic (web + mobile). Used only by the flag-gated New Season
// editors (FeatureFlagDictionary.NEW_SEASON); nothing in the V1 screens calls it.
var axios = require('axios');
var { error_message } = require('@managers/helpers');

const V2_FARMING_UNITS_PATH = 'v2/farming_units';
const V2_SEASONS_PATH = 'v2/seasons';

export const SEASON_STATE = Object.freeze({
  TEMPLATE: 'template',
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  UNKNOWN: 'unknown',
});

// FastAPI errors arrive as {detail}; fall back to the shared V1 extractor.
export var v2_error_message = error_object => {
  const detail = error_object?.response?.data?.detail;
  if (typeof detail === 'string' && detail) {
    return detail;
  }
  return error_message(error_object || {});
};

const farmingUnitPath = (distribution_id, farming_unit_id) =>
  V2_FARMING_UNITS_PATH + '/' + distribution_id + '/' + farming_unit_id;

const seasonPath = (distribution_id, farming_unit_id, season_id) =>
  V2_SEASONS_PATH +
  '/' +
  distribution_id +
  '/' +
  farming_unit_id +
  '/' +
  season_id;

// {distributions: [{id, name, farming_units: [{id, name, country, region,
// salesforce_id, settings, role}]}]} — only the distributions / farming-units
// tables, only what the caller may see. Monday ID = salesforce_id.
export var get_v2_distributions = () =>
  axios.get('v2/distributions').then(res => res.data);

export var get_farming_unit_tree = (distribution_id, farming_unit_id) =>
  axios
    .get(farmingUnitPath(distribution_id, farming_unit_id) + '/tree')
    .then(res => res.data);

// {season, block, field_group}; season.sensors = the season's live sensors in
// the user's units (same shape V1 puts on field.sensors).
export var get_season = (distribution_id, farming_unit_id, season_id) =>
  axios
    .get(seasonPath(distribution_id, farming_unit_id, season_id))
    .then(res => res.data);

// body: {fields: [{id|null, name, blocks: [{id|null, name, geo_data?}]}], deleted_block_ids: []}
// Resolves with {saved: true, farming_unit_id}; re-fetch the tree afterwards.
export var put_farming_unit_layout = (distribution_id, farming_unit_id, body) =>
  axios
    .put(farmingUnitPath(distribution_id, farming_unit_id) + '/layout', body)
    .then(res => res.data);

// body: the V1 update-field request shape (see fieldManager.build_update_field_body).
// Resolves with {season} (the saved season, including its live sensors).
export var put_season = (distribution_id, farming_unit_id, season_id, body) =>
  axios
    .put(seasonPath(distribution_id, farming_unit_id, season_id), body)
    .then(res => res.data);

// body: {block_id, ...V1 keys the user changed}. Creates the block's
// pre-season (a copy of its current season). Resolves with {season}.
export var post_pre_season = (distribution_id, farming_unit_id, body) =>
  axios
    .post(seasonPath(distribution_id, farming_unit_id, 'pre_season'), body)
    .then(res => res.data);

// "Activate now". body: the V1 create-field request (see
// fieldManager.build_create_field_body). Resolves with
// {season_id, archived_season_ids}; re-fetch the tree afterwards.
export var post_activate_pre_season = (
  distribution_id,
  farming_unit_id,
  season_id,
  body
) =>
  axios
    .post(
      seasonPath(distribution_id, farming_unit_id, season_id) + '/activate',
      body
    )
    .then(res => res.data);
